module.exports = __webpack_public_path__ + "img/cz.b8ea3539.svg";